import { type ReactNode } from 'react';
import clsx from 'clsx';
import { ResumeFunnelButton } from '@hungryroot/funnel';
import { HomepageIcon, HomepageIconVariant } from '@hungryroot/homepage';
import styles from './PreAuthHeader.module.css';

type Props = {
  className?: string;
  action?: ReactNode;
  actionContainerClassName?: string;
  isOpaque?: boolean;
  catalogNavigation?: ReactNode;
};

export function PreAuthHeader(props: Props) {
  const { className, action, actionContainerClassName, catalogNavigation } =
    props;

  return (
    <header className={clsx(styles.container, className)}>
      <nav className={styles.nav}>
        {catalogNavigation}
        <div className={styles['logo-container']}>
          <a href="/">
            <HomepageIcon
              variant={HomepageIconVariant.DishLogo}
              className={styles.logo}
            />
          </a>
        </div>
        <div className={`${styles['nav-links']} ${actionContainerClassName}`}>
          {action}
          <ResumeFunnelButton
            startQuizText="Get started"
            style="success"
            prominence="primary"
            size="medium"
            className={styles.cta}
          />
        </div>
      </nav>
    </header>
  );
}
